import React, { useState } from "react";
// import T from "i18n-react";
import Styles from "./styles.module.scss";
import { connect } from "react-redux";
import { IVenueOrderTypesProps } from "./types.d";
import { _SetSelectedMenuType, _resetCart } from "../../../redux/actions/index";
import { SelectedOrderType } from "../../Payment/types.d";
import { useHistory } from "react-router-dom";
import { Collapse } from "antd";
import { useSelector } from "react-redux";
import OrderType from "./OrderType/OrderType";

import useCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import { ReactComponent as CollectionBagSVG } from "../../../imges/CollectionBag.svg";
import { ReactComponent as BicycleSVG } from "../../../imges/Bicycle.svg";
import { ReactComponent as FoodPlateSVG } from "../../../imges/FoodPlate.svg";
import { YellowColorCodeForOrderTypeSvgs } from "../../Payment/OrderTypesComponent/OrderTypesComponent";
import VenueOrderTypeHeader from "./VenueOrderTypeHeader/VenueOrderTypeHeader";
import T from "i18n-react";
import { useDrawer } from "../../Drawer/DrawerContext";
import PostCodeChecker from "../PostCodeChecker/PostCodeChecker";

const { Panel } = Collapse;

export enum OrderTypeTextsENUM {
  PreparationTime = "Venue.PrepTime",
  DeliveryFee = "Payment.DeliveryFee",
  DeliveryTime = "Payment.DeliveryTime",
  MinOrderValue = "Payment.MinOrder",
}

function VenueOrderTypes(props: IVenueOrderTypesProps) {
  const [activeKey, setActiveKey] = useState<SelectedOrderType | any>();
  const { formatCurrency } = useCurrency();
  const history = useHistory();
  const SelectedMenuType = useSelector((state: any) => state.SelectedMenuType);
  const Venue = useSelector((state: any) => state.Venue);
  const formattedDeliveryFee = formatCurrency(props.DeliveyFee);
  const formattedMinOrderValue = formatCurrency(
    parseFloat(props.MinOrderValue) * 100
  );
  const { openDrawer, closeDrawer } = useDrawer()!;

  const OrderTypeTexts = {
    TABLE: [
      {
        key: OrderTypeTextsENUM.PreparationTime,
        value: `${props.PrepTime}`,
      },
    ],
    CLICK: [
      {
        key: OrderTypeTextsENUM.PreparationTime,
        value: `${props.PrepTime}`,
      },
    ],
    DELIVERY: [
      {
        key: OrderTypeTextsENUM.DeliveryFee,
        value: props.DeliveyFee > 0 ? formattedDeliveryFee : "Free",
      },
      {
        key: OrderTypeTextsENUM.DeliveryTime,
        value: `${props.DeliveyTime}`,
      },
      {
        key: OrderTypeTextsENUM.MinOrderValue,
        value: formattedMinOrderValue,
      },
    ],
  };

  const handleViewMenuPage = (SelectedOrder: SelectedOrderType) => {
    if (
      SelectedOrder === SelectedOrderType.DELIVERY &&
      Venue.delivery_radius_km
    ) {
      openDrawer(
        PostCodeChecker as any,
        {
          closeDrawer: closeDrawer,
          goToMenuPage: () => goToMenuPage(SelectedOrder),
        },
        "bottom",
        "PostCodeChecker"
      );
    } else {
      goToMenuPage(SelectedOrder);
    }
  };

  const goToMenuPage = (SelectedOrder: SelectedOrderType) => {
    if (SelectedOrder !== SelectedMenuType) {
      props._resetCart();
    }
    props._SetSelectedMenuType(SelectedOrder);
    history.push(props.MenuPageLink);
  };

  const checkOrderTypeSelected = (type: SelectedOrderType) => {
    let active: Array<string> | undefined = activeKey;
    if (active !== undefined) {
      return activeKey.includes(type);
    }
    return false;
  };
  const renderCollapseItem = (type) => {
    switch (type) {
      case SelectedOrderType.TABLE:
        return (
          <OrderType
            buttonText="ViewTable"
            infoArray={OrderTypeTexts.TABLE}
            handleButtonClick={() =>
              handleViewMenuPage(SelectedOrderType.TABLE)
            }
            selected={checkOrderTypeSelected(type)}
          />
        );

      case SelectedOrderType.CLICK:
        return (
          <OrderType
            buttonText="ViewCollection"
            infoArray={OrderTypeTexts.CLICK}
            handleButtonClick={() =>
              handleViewMenuPage(SelectedOrderType.CLICK)
            }
            selected={checkOrderTypeSelected(type)}
          />
        );

      case SelectedOrderType.DELIVERY:
        return (
          <OrderType
            buttonText="ViewDelivery"
            infoArray={OrderTypeTexts.DELIVERY}
            handleButtonClick={() =>
              handleViewMenuPage(SelectedOrderType.DELIVERY)
            }
            noMinValue={!props.MinOrderValue}
            selected={checkOrderTypeSelected(type)}
          />
        );

      default:
        break;
    }
  };

  const renderOrderTypes = () => {
    let OrderTypes = [];
    if (props.TableServiceEnable) {
      OrderTypes.push(
        <Panel
          className={Styles.CollapseItems}
          // "Table service"
          header={
            <VenueOrderTypeHeader
              svgImage={
                <FoodPlateSVG
                  fill={
                    checkOrderTypeSelected(SelectedOrderType.TABLE)
                      ? YellowColorCodeForOrderTypeSvgs
                      : "transparent"
                  }
                />
              }
              title={"Venue.TableService"}
              selected={checkOrderTypeSelected(SelectedOrderType.TABLE)}
            />
          }
          key={SelectedOrderType.TABLE}
        >
          {renderCollapseItem(SelectedOrderType.TABLE)}
        </Panel>
      );
    }
    if (props.CollectionEnable) {
      OrderTypes.push(
        <Panel
          className={Styles.CollapseItems}
          header={
            <VenueOrderTypeHeader
              svgImage={
                <CollectionBagSVG
                  fill={
                    checkOrderTypeSelected(SelectedOrderType.CLICK)
                      ? YellowColorCodeForOrderTypeSvgs
                      : "transparent"
                  }
                />
              }
              title={"Venue.Collection"}
              selected={checkOrderTypeSelected(SelectedOrderType.CLICK)}
            />
          }
          key={SelectedOrderType.CLICK}
        >
          {renderCollapseItem(SelectedOrderType.CLICK)}
        </Panel>
      );
    }
    if (props.DeliveryEnable) {
      OrderTypes.push(
        <Panel
          className={Styles.CollapseItems}
          header={
            <VenueOrderTypeHeader
              svgImage={
                <BicycleSVG
                  fill={
                    checkOrderTypeSelected(SelectedOrderType.DELIVERY)
                      ? YellowColorCodeForOrderTypeSvgs
                      : "transparent"
                  }
                />
              }
              title={"Venue.Delivery"}
              selected={checkOrderTypeSelected(SelectedOrderType.DELIVERY)}
            />
          }
          key={SelectedOrderType.DELIVERY}
        >
          {renderCollapseItem(SelectedOrderType.DELIVERY)}
        </Panel>
      );
    }

    return OrderTypes;
  };
  const orderTypes = renderOrderTypes();
  return (
    <>
      {orderTypes.length > 0 && (
        <div className={Styles.description + " mb-1"}>
          <span>{T.translate("Venue.Ordering")}</span>
        </div>
      )}
      <div id="VenueOrderTypes" className={Styles.VenueOrderTypes}>
        <Collapse activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
          {orderTypes}
        </Collapse>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, {
  _SetSelectedMenuType,
  _resetCart,
})(VenueOrderTypes);
